/**
 * Created by Andrey Okhotnikov on 08.09.2026
 * Email: hunterov1984@gmail.com
 */
import { OrNull } from '@app/utils/types.helper';
import { LabelInterface } from '@app/interfaces/label.interface';
import { TimelineItem } from '@app/interfaces/label-timeline.interface';

export interface CurrentCall {
  UUID: string;
  DIRECTION_IN: boolean;
  CALL_START: number;
  PHONE: string;
  OUR_DID: string;
  LABEL: OrNull<LabelInterface>;
  TIMELINE: OrNull<TimelineItem[]>;
  WAITING_QUEUE: number;
  POPUP: boolean;
}

export enum NotificationEventType {
  POPUP = 'popup',
  CALL_START = 'call_start',
  CALL_END = 'call_end',
}

export type NotificationEvent = PopupNotificationEvent | CallStartNotificationEvent | CallEndNotificationEvent;

export interface PopupNotificationEvent {
  type: NotificationEventType.POPUP;
  title?: string;
  html: string;
}

export interface CallStartNotificationEvent {
  type: NotificationEventType.CALL_START;
  call: CurrentCall;
}

export interface CallEndNotificationEvent {
  type: NotificationEventType.CALL_END;
  call: Pick<CurrentCall, 'UUID'>;
}

export function isPopupNotificationEvent(event: NotificationEvent): event is PopupNotificationEvent {
  return event.type === NotificationEventType.POPUP;
}

export function isCallStartNotificationEvent(event: NotificationEvent): event is CallStartNotificationEvent {
  return event.type === NotificationEventType.CALL_START;
}

export function isCallEndNotificationEvent(event: NotificationEvent): event is CallEndNotificationEvent {
  return event.type === NotificationEventType.CALL_END;
}
